import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Breadcrumbs,
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
} from "@material-ui/core";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import HomeStyles from "pages/HomeStyles";
import {
  setCurrentPage,
  getPictreePhotoShootByAssetNtt,
  getPictreePhotoShootTrendByAssetNtt,
  setPictreeChartSize,
} from "actions";
import * as C from "components";
import * as V from "styles/variables";
import PhotoShootAssetTypeNtt from "components/PicTree/Home/PhotoShootAssetTypeNtt";
import ChartConfig from "utils/ChartConfig";
import LineChartPictreePhotoShoot from "components/Charts/LineChartPictreePhotoShoot";
import PicTreeTablePhotoSubTypeNtt from "components/Table/PicTreeTablePhotoSubTypeNtt";
import CalendarRangePicTreeNtt from "components/Calendar/CalendarRangePicTreeNtt";

const useStyles = makeStyles((theme) =>
  createStyles({
    loaderBox: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 280,
    },
    loaderBarImg: {
      width: 40,
    },
    breadcrumbs: {
      marginTop: 16,
      minHeight: 30,
    },
    gridSection: {
      marginTop: theme.spacing(1),
    },
    selectGameTxt: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: 280,
      flexWrap: "wrap",
      "& > *": {
        margin: theme.spacing(0.5),
      },
    },
  })
);

const PicTreeReviewByAssetTypeNtt = ({
  setCurrentPage,
  pageTopLoader,
  dateRangePicTreeNtt,
  getPictreePhotoShootByAssetNtt,
  photoShootTrendByAsset,
  getPictreePhotoShootTrendByAssetNtt,
  setPictreeChartSize,
}) => {
  const classes = useStyles();
  const [chartState, setChartState] = useState(true);
  const [initialDataCall, setInitialDataCall] = useState(true);
  const legendData =
    photoShootTrendByAsset.length > 0
      ? Object.keys(photoShootTrendByAsset[0])
          .filter((key) => key !== "date")
          .map((key) => ChartConfig.chartLabelPicTreeAssetTypeNtt[key] || key)
      : [];

  useEffect(() => {
    setCurrentPage(window.location.pathname);
  }, []);

  useEffect(() => {
    if (
      dateRangePicTreeNtt[0] !== null &&
      dateRangePicTreeNtt[1] !== null &&
      initialDataCall
    ) {
      getPictreePhotoShootByAssetNtt();
      getPictreePhotoShootTrendByAssetNtt("day");
      setInitialDataCall(false);
    }
  }, [dateRangePicTreeNtt]);

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: -16, marginBottom: 8 }}
          justifyContent="space-between"
        >
          <Grid item>
            <Breadcrumbs separator="›" className={classes.breadcrumbs}>
              <Typography>PicTrée NTT ME</Typography>
              <Typography variant="body1">撮影</Typography>
              <Typography variant="body1">アセットタイプ別</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item className={classes.fillRemailSpace}></Grid>
          <Grid item>
            <CalendarRangePicTreeNtt mDate={"2024/05/17"} page="pictree" pictree />
          </Grid>
        </Grid>

        <Grid container spacing={0} style={{ marginTop: 0 }}>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <div className={classes.cardContentSection}>
                  <PhotoShootAssetTypeNtt />
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: 16, marginRight: 16, marginBottom: 8 }}
          justifyContent="space-between"
        >
          <Grid item>
            <Grid
              container
              spacing={0}
              direction="row"
              style={{ marginTop: 0, marginRight: 16, marginBottom: 8 }}
              justifyContent="flex-end"
            >
              <Grid item></Grid>
            </Grid>
          </Grid>
        </Grid>

        <>
          <Grid container spacing={1} className={classes.gridSection}>
            <Grid item xs={12} md={12} lg={12}>
              {pageTopLoader ? (
                <div className={classes.loaderBox}>
                  <img
                    className={classes.loaderBarImg}
                    src={`/static/images/loader-bar.gif`}
                  />
                </div>
              ) : chartState ? (
                photoShootTrendByAsset.length > 0 ? (
                  <LineChartPictreePhotoShoot
                    legend={legendData}
                    lblSaveImage={""}
                    xAisData={photoShootTrendByAsset[0]["date"]}
                    seriesData={photoShootTrendByAsset}
                    chartType={"line"}
                    chartConfig={ChartConfig.chartLabelPicTreeAssetTypeNtt}
                    yAxis={[{
                      type: 'value',
                      name: '撮影基数',
                      alignTicks: true,
                      axisLine: {
                        show: true,
                      },
                      axisLabel: {
                        formatter: '{value}'
                      }
                    }]}
                    colorValue={V.genericColorPallette}
                  />
                ) : (
                  <div className={classes.selectGameTxt}>
                    <Chip
                      label="No Data"
                      style={{
                        color: V.textColor,
                        backgroundColor: V.placeholderColor,
                      }}
                    />
                  </div>
                )
              ) : null}
            </Grid>
          </Grid>
          <Grid container spacing={1} className={classes.gridSection}>
            <Grid item xs={12} md={12} lg={12}>
              <PicTreeTablePhotoSubTypeNtt photoShootTrend={photoShootTrendByAsset} game="PicTree" />
            </Grid>
          </Grid>
        </>
      </C.ContentWrapper>
    </Fragment>
  );
};

PicTreeReviewByAssetTypeNtt.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  pageTopLoader: state.page.pageTopLoader,
  dateRangePicTreeNtt: state.page.dateRangePicTreeNtt,
  photoShootTrendByAsset: state.pictreeNtt.photoShootTrendByAsset,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getPictreePhotoShootByAssetNtt: () => dispatch(getPictreePhotoShootByAssetNtt()),
  getPictreePhotoShootTrendByAssetNtt: (param) => dispatch(getPictreePhotoShootTrendByAssetNtt(param)),
  setPictreeChartSize: (param) => dispatch(setPictreeChartSize(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(HomeStyles, { withTheme: true })(PicTreeReviewByAssetTypeNtt));
